export default __webpack_public_path__ + "static/media/chevron-right1.025fe0b3.svg";